import {FC} from "react";
import {PageBase} from "@/app2/shared/layouts/PageBase";
import {CourseLibraryBanner} from "./CourseLibraryBanner";
import {makeStyles} from "tss-react/mui";
import {CourseLibraryContent} from "./CourseLibraryContent";
import {Box} from "@mui/material";

const useStyles = makeStyles()((theme) => ({
	pageBase: {
		[theme.breakpoints.up("lg")]: {
			"& [class*='menuIcon']": {
				display: "none"
			}
		},
		[theme.breakpoints.down("sm")]: {
		}
	},
	container: {
		[theme.breakpoints.up("sm")]: {
			padding: "0 0px"
		}
	},
	library: {
		paddingBottom: "70px",
		width: "100%"
	}
}));

export const CourseLibraryPage: FC = () => {
	const {classes} = useStyles();

	return (
		<PageBase className={classes.pageBase} contentWidth="100%" disableSideBar>
			<Box className={classes.container}>
				<CourseLibraryBanner />
				<CourseLibraryContent className={classes.library} />
			</Box>
		</PageBase>
	);
};

